import { FC, useCallback, useMemo } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useSnapshot } from 'valtio';
import ModalDialog from '../../common/components/ModalDialog';
import ApplicationsStore from '../stores/applications-store';
import AppOwnerAssignContent from '../../elements/AppOwnerAssign/AppOwnerAssignContent';
import {
  saveApplicationsOwners,
  useAppOwners,
} from '../../application-owners/api/applications-owners-api';

const OwnersModal: FC<React.PropsWithChildren<OwnersModalProps>> = ({
  open,
  setOpen,
}) => {
  const { selected } = useSnapshot(ApplicationsStore);
  const { appOwnersSuggestions, disableAppOwnerAssignSubmit, isLoading } =
    useAppOwners();
  const { user } = useAuth0();
  const owners = appOwnersSuggestions.filter(o => o.email !== user?.email);
  const me =
    user?.email && user?.name
      ? { name: user.name, email: user.email }
      : undefined;
  const appIds = useMemo(
    () => Object.keys(selected).filter(key => selected[key]),
    [selected],
  );
  const onClose = useCallback(() => setOpen(false), [setOpen]);
  const onSubmit = useCallback(
    () => saveApplicationsOwners(onClose),
    [onClose],
  );

  return (
    <>
      {me && (
        <ModalDialog
          onClose={onClose}
          modalHeader='Assign Application Owners'
          open={open}>
          <AppOwnerAssignContent
            saveInProgress={isLoading}
            appIds={appIds}
            disableAppOwnerAssignSubmit={disableAppOwnerAssignSubmit}
            onSubmit={onSubmit}
            owners={[me, ...owners]}
            onCancel={onClose}
          />
        </ModalDialog>
      )}
    </>
  );
};

export interface OwnersModalProps {
  open: boolean;
  setOpen: (value: boolean) => void;
}

export default OwnersModal;
